import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { config } from '../../../../../config/config';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { isNullOrUndefined } from '../../../../common/extensions';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { EventSpiderModalData } from './event.spider.modal.provider';
import { SelectComponent } from '../../../../common/components/select/select.component';
import { timezoneConfig } from '../../../../../config/timezone';
import { Observable } from 'rxjs/Observable';
import { finalize, map, startWith } from 'rxjs/operators';
import { EventTimeService } from '../../../../services/event.time.service';
import { AddSpiderEvenetsModalComponent } from '../../add.spider.events.modal/add.spider.events.modal.component';
import {
  AddSpiderEventsModalActions,
  AddSpiderEventsModalData,
} from '../../add.spider.events.modal/add.spider.events.modal.provider';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';
import { ModalService } from '../../../../common/services/modal.service';
import { MultipleFieldsComponent } from '../../../../common/components/multiple.fields/multiple.fields.component';
import { SerpConfig } from '../../../../models/admin/serp.config';
import { SetEventPageTagModalComponent } from './set.eventpage.tag.modal/set.eventpage.tag.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { AddEventbriteEvenetsModalComponent } from '../../add.eventbrite.events.modal/add.eventbrite.events.modal.component';
import {
  AddEventbriteEventsModalActions,
  AddEventbriteEventsModalData,
} from '../../add.eventbrite.events.modal/add.eventbrite.events.modal.provider';

@Component({
  templateUrl: './event.spider.modal.component.html',
  styleUrls: ['./event.spider.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventSpiderModalComponent extends BaseComponent {
  public myControl = new FormControl();
  public loading = false;
  public limit = 30;
  public serpCityLimit = 0;
  public accounts = [];

  public regionalAccountLimit = 30;
  public isSyncEventAfterAddingDMOAccounts = true;

  public form: FormGroup;
  public pagesLimitSource = [];
  public isAllowOnlineEvents;
  public pages: {
    facebook: string[];
    eventbrite: SpiderPage[];
    serpGoogle: { url: string; tag?: string }[];
    serpGoogleKeywords: { url: string; tag?: string }[];
  };
  public serpBlockKeywords: string[] = [];
  public enteredCity = { address: '', lat: 0, lng: 0 };
  public account: EventSpiderModalData;
  public timezoneSource = [];
  public fieldForm: FormGroup;
  timezoneSourceFiltered: Observable<string[]>;
  public lastRunTime;
  public isOpenRegionalAccountType = false;

  serpGoogleType = 'city';
  serpGooglekeywordsCity;
  serpGoogleCityPages;
  serpGoogleKeywordsPages;
  jobKeywordsCity;
  jobKeywords: { keyword: string; city: string; state: string; country: string }[] = [];
  jobKeywordsDisplayText: string[] = [];
  errorMessage: string;
  regionalAccounts: string[] = [];

  public eventbriteEventIdsOrUrls: string;
  public testingEventbritePage: SpiderPage;

  @ViewChild('limitSelect') limitSelect: SelectComponent;
  @ViewChild('multipleFieldsComponent')
  serpCityMultipleFields: MultipleFieldsComponent;
  @ViewChild('keywordsMultipleFieldsComponent')
  keywordsMultipleFields: MultipleFieldsComponent;

  public selectedTabIndex = 0;

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private dialog: MatDialog,
    private schedulerApiService: SchedulerApiService,
    private dialogRef: MatDialogRef<EventSpiderModalComponent>,
    data: EventSpiderModalData
  ) {
    super();
    this.account = Object.assign({}, data);
    this.form = this.formBuilder.group({
      limit: [null],
      city: [null],
      eventbriteEventIdsOrUrls: [null],
    });
  }

  ngOnInit() {
    this.loadSpiderEventPage();

    this.timezoneSource = timezoneConfig;
    this.accountApiService.getEventTimezone(this.account.account._id).subscribe((res) => {
      if (res.timezoneFormatter) {
        this.myControl.setValue(res.timezoneFormatter);
        this.timezoneSource.forEach((item) => {
          if (item.value === res.timezoneFormatter) {
            this.myControl.setValue(item.name);
          }
        });
      }
    });

    this.accountApiService.getSerpBlockKeywords().subscribe((blocked: { name; value }) => {
      console.log(blocked);
      this.serpBlockKeywords = blocked.value.split(', ');
    });

    this.accountApiService.getJobKeywords(this.account.account._id).subscribe((result) => {
      this.jobKeywords = result.data;
      this.jobKeywordsDisplayText = this.jobKeywords.map(
        (x) => `${x.keyword} (${x.city}, ${x.state})`
      );
    });

    this.loadIsAllowOnlineEvents();

    this.accountApiService
      .getEventCronjobLastRunTime(this.account.account.userName)
      .subscribe((data) => {
        console.log(data);
        this.lastRunTime = data;
      });

    this.fieldForm = this.fb.group({
      city: [null, null],
    });

    setTimeout(() => {
      this.timezoneSourceFiltered = this.myControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value))
      );
    }, 500);

    this.isOpenRegionalAccountType = this.account.account.toggle.regionalAccountType;
    this.regionalAccounts = this.account.account.regionalAccounts;
  }

  public parseTime(time: string) {
    return new Date(time).toLocaleString();
  }

  public loadSpiderEventPage() {
    this.loading = true;
    console.log('account', this.account);
    this.accountApiService.getSpiderEventPages(this.account.account._id).subscribe((pages) => {
      this.limit = isNullOrUndefined(pages.pagesMax) ? config.maxLocationFeedLimit : pages.pagesMax;
      this.pages = {
        facebook: pages.pages.filter((x) => x.socialName === 'facebook').map((x) => x.url),
        eventbrite: pages.pages.filter((x) => x.socialName === 'eventbrite'), //.map((x) => x.url),
        serpGoogle: pages.pages
          .filter((x) => x.socialName === 'serp|google')
          .map((x) => {
            return { url: x.url, tag: x.tag };
          }),
        serpGoogleKeywords: pages.pages
          .filter((x) => x.socialName === 'serp|google|keywords')
          .map((x) => {
            return { url: x.url, tag: x.tag };
          }),
      };
      this.serpGoogleCityPages = this.pages.serpGoogle.map(
        (x) => `${x.url}${x.tag ? `(${x.tag})` : ''}`
      );
      this.serpGoogleKeywordsPages = this.pages.serpGoogleKeywords.map(
        (x) => `${x.url}${x.tag ? ` (${x.tag})` : ''}`
      );
      this.loading = false;

      this.pagesLimitSource = [
        {
          text: 'Unlimited',
          value: 0,
          selected: this.limit === 0,
        },
        {
          text: '5',
          value: 5,
          selected: this.limit === 5,
        },
        {
          text: '15',
          value: 15,
          selected: this.limit === 15,
        },
        ,
        {
          text: '30',
          value: 30,
          selected: this.limit === 30,
        },
        {
          text: '60',
          value: 60,
          selected: this.limit === 60,
        },
        {
          text: '90',
          value: 90,
          selected: this.limit === 90,
        },
        {
          text: '120',
          value: 120,
          selected: this.limit === 120,
        },
        {
          text: '150',
          value: 150,
          selected: this.limit === 150,
        },
      ];

      // to ensure value is selected after dropdown init
      setTimeout(() => {
        this.limitSelect.setSelected(this.limit);
      }, 500);
    });
  }

  public onAddKeywordsPage(value) {
    this.pages.serpGoogleKeywords.push({
      url: value,
      tag: this.filterCountryName(this.serpGooglekeywordsCity.address), // use "tag" to store city name for filtering events only in the city
    });
  }

  public onRemoveKeywordsPage(data: { index: number; item: any }) {
    this.pages.serpGoogleKeywords.splice(data.index, 1);
  }

  public onAddJobKeywords(value) {
    const displayText = `${value} (${this.jobKeywordsCity.city}, ${this.jobKeywordsCity.state})`;
    this.jobKeywords.push({
      keyword: value,
      city: this.jobKeywordsCity.city,
      state: this.jobKeywordsCity.state,
      country: this.jobKeywordsCity.country,
    });

    // remove the last item in jobKeywordsDisplayText
    this.jobKeywordsDisplayText.splice(this.jobKeywordsDisplayText.length - 1, 1);
    this.jobKeywordsDisplayText.push(displayText);
  }

  public onRemoveJobKeywords(data: { index: number; item: any }) {
    this.jobKeywords.splice(data.index, 1);
    // this.jobKeywordsDisplayText.splice(data.index, 1);
  }

  public saveJobKeywords(event: ButtonTriggerEvent) {
    console.log(this.jobKeywordsCity);
    this.accountApiService
      .saveJobKeywords(
        this.account.account._id,
        this.jobKeywords.map((x) => ({
          keyword: x.keyword,
          city: x.city,
          state: x.state,
          country: x.country,
        }))
      )
      .pipe(
        finalize(() => {
          event.complete();
        })
      )
      .subscribe(() => {
        this.alertify.success('Job keywords saved successfully');
      });
  }

  public isUseOwnKeywordsChanged() {}

  public editEventbriteCityCode(page: SpiderPage) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = page;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'width-modal-2';
    let dialogRef = this.dialog.open(SetEventPageTagModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((data: SpiderPage) => {
      if (data) {
        for (let i = 0; i < this.pages.eventbrite.length; i++) {
          if (
            this.pages.eventbrite[i]._id &&
            data._id &&
            this.pages.eventbrite[i]._id === data._id
          ) {
            this.pages.eventbrite[i] = data;
          }
        }
      }
    });
  }

  public addEventbriteCityCode() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'width-modal-2';
    let dialogRef = this.dialog.open(SetEventPageTagModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((data: SpiderPage) => {
      if (data) {
        if (this.pages.eventbrite.any((x) => x.url === data.url)) {
          this.alertify.warning('Page already exists');
          return;
        }
        this.pages.eventbrite.push(data);
      }
    });
  }

  public removeEventbriteCityCode(page: SpiderPage) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        if (page._id) {
          this.pages.eventbrite = this.pages.eventbrite.filter((x) => x._id !== page._id);
        } else {
          this.pages.eventbrite = this.pages.eventbrite.filter((x) => x.url !== page.url);
        }
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: `Are you sure you want to remove this page?`,
      confirmModalConfirmButtonText: 'Yes',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: false,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public testEventbritePage(page: SpiderPage) {
    if (this.testingEventbritePage) return;

    this.testingEventbritePage = page;
    this.accountApiService
      .testPullEventbritePage(this.account.account._id, { url: page.url, tag: page.tag })
      .finally(() => (this.testingEventbritePage = null))
      .subscribe(
        (res) => {
          if (!res || res.error) {
            this.alertify.error((res && res.error) || 'Failed to pull this Eventbrite page');
            return;
          }

          const actions = <AddEventbriteEventsModalActions>{
            confirm: () => {},
            cancel: () => {},
          };
          this.modalService.show({
            component: AddEventbriteEvenetsModalComponent,
            providers: [
              { provide: AddEventbriteEventsModalActions, useValue: actions },
              {
                provide: AddEventbriteEventsModalData,
                useValue: new AddEventbriteEventsModalData(
                  this.account.account,
                  res.events || [],
                  res.addressFilteredEvents || [],
                  res.targetCity || '',
                  res.targetState || ''
                ),
              },
            ],
            panelClass: 'width-modal-90p',
          });
        },
        () => this.alertify.error('Failed to pull this Eventbrite page')
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLocaleLowerCase();
    return this.timezoneSource.filter((option) =>
      option.value.toLocaleLowerCase().includes(filterValue)
    );
  }

  close() {
    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    let data = this.pages.facebook.map((x) => {
      x = x.replace('?ref=page_internal', '');
      return new SpiderPage('facebook', x);
    });
    data.push(
      ...this.pages.eventbrite.map((x) => {
        return x;
      })
    );
    data.push(
      ...this.serpGoogleCityPages.map((x) => {
        return new SpiderPage('serp|google', x);
      })
    );
    data.push(
      ...this.pages.serpGoogleKeywords.map((x) => {
        return new SpiderPage('serp|google|keywords', x.url, x.tag);
      })
    );
    this.accountApiService
      .setSpiderEventPages(this.account.account._id, data)
      .finally(event.complete)
      .subscribe(() => {
        // this.alertify.successfully('Save events');
        this.dialogRef.close();
      });

    const custom = this.account.account.facebookFeeds.blockKeywords;
    this.accountApiService
      .setSerpBlockKeywords(custom.isUseOwn ? custom.keywords : this.serpBlockKeywords, {
        userName: this.account.account.userName,
        isUseOwn: custom.isUseOwn,
      })
      .subscribe();

    if (this.isOpenRegionalAccountType) {
      this.accountApiService
        .setRegionalAccounts(
          this.account.account.userName,
          this.regionalAccounts,
          this.isSyncEventAfterAddingDMOAccounts
        )
        .subscribe((data) => {
          if (!data.success) {
            this.alertify.error(data.msg);
          }
        });
    }
  }

  public async setLimit(event: ButtonTriggerEvent) {
    this.accountApiService
      .setEventPagesLimit(this.account.account._id, this.limit)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Set page limit');
        this.dialogRef.close();
      });
  }

  public limitChanged(value) {
    this.limit = value.value;
  }

  public async pullEventbriteEvent(event: ButtonTriggerEvent) {
    this.errorMessage = '';
    if (!this.eventbriteEventIdsOrUrls) {
      event.complete();
      return;
    }
    let eventIds = this.eventbriteEventIdsOrUrls.includes(';')
      ? this.eventbriteEventIdsOrUrls.split(';')
      : [this.eventbriteEventIdsOrUrls];

    eventIds = eventIds.map((id) => id.trim());
    const processedEventIds = eventIds
      .map((id) => {
        id = id.trim();
        let eventId = '';
        if (this.isUrl(id)) {
          const parsed = EventSpiderModalComponent.parseEventbriteUrl(id);
          if (parsed && parsed.eventId) {
            eventId = parsed.eventId;
          }
        } else {
          eventId = id;
        }
        return eventId;
      })
      .filter((x) => x);

    if (processedEventIds.length === 0) {
      event.complete();
      this.errorMessage = 'No valid eventbrite event id or url found';
      return;
    }

    this.accountApiService
      .getEventbriteEvents(this.account.account._id, processedEventIds)
      .finally(event.complete)
      .subscribe((res) => {
        if (res && res.error) {
          this.errorMessage = 'Pull eventbrite events error: ' + res.error + '.';
        } else {
          if (res && res.events && res.events.length) {
            let actions = <AddEventbriteEventsModalActions>{
              confirm: (buttonEvent: ButtonTriggerEvent) => {
                this.eventbriteEventIdsOrUrls = '';
                buttonEvent.complete();
              },
              cancel: () => {},
            };
            this.modalService.show({
              component: AddEventbriteEvenetsModalComponent,
              providers: [
                { provide: AddEventbriteEventsModalActions, useValue: actions },
                {
                  provide: AddEventbriteEventsModalData,
                  useValue: new AddEventbriteEventsModalData(this.account.account, res.events),
                },
              ],
              panelClass: 'width-modal-90p',
            });
          }
        }
      });
  }

  public changeAllowOnlineEvents() {
    this.accountApiService
      .setIsAllowOnlineEvents(this.account.account._id, this.isAllowOnlineEvents)
      .subscribe(() => {
        this.alertify.successfully(
          `Set ${this.isAllowOnlineEvents ? 'allow' : 'not allow'} online events`
        );
      });
  }

  public loadIsAllowOnlineEvents() {
    this.accountApiService.getIsAllowOnlineEvents(this.account.account._id).subscribe((data) => {
      this.isAllowOnlineEvents = data.isAllowOnlineEvents || false;
    });
  }

  public async setTimezone(event: ButtonTriggerEvent) {
    this.accountApiService
      .setEventTimezone(this.account.account._id, this.myControl.value.split(' ')[0])
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Set event timezone');
        this.dialogRef.close();
      });
  }

  public async testSerpGoogle($event: ButtonTriggerEvent) {
    // const serpCityToAdd = this.serpCityMultipleFields.getText();

    if (!this.enteredCity || !this.enteredCity.address) {
      $event.complete();
      alert('Please enter a city, e.g., Savannah, GA');
      return;
    }
    let serpCityToAdd = this.enteredCity.address;
    serpCityToAdd = serpCityToAdd.toLocaleLowerCase().replaceAll(', usa', '');
    const serpConfig = new SerpConfig(false, 0, 0, true);
    this.schedulerApiService
      .serpApi(this.account.account.userName, serpCityToAdd, serpConfig)
      .finally($event.complete)
      .subscribe((result: { success: boolean; events: any[]; msg: string }) => {
        console.log(result);

        if (!result || !result.success) {
          alert(result.msg);
          return;
        }
        if (!result.events.length) {
          alert(`No events found`);
          return;
        }
        result.events.forEach((x) => EventTimeService.processEventTime(x, false));
        const page = [{ events: result.events, pageLink: serpCityToAdd }];
        this.modalService.show({
          component: AddSpiderEvenetsModalComponent,
          providers: [
            { provide: AddSpiderEventsModalActions, useValue: null },
            {
              provide: AddSpiderEventsModalData,
              useValue: new AddSpiderEventsModalData(
                this.account.account.userName,
                [],
                page,
                '',
                true
              ),
            },
          ],
          panelClass: 'width-modal-90p',
        });
      });
  }

  public citySelected() {
    if (this.enteredCity && this.enteredCity.address) {
      const filtered = this.enteredCity.address.replaceAll(', USA', '').replace(/\d+/g, '');
      this.serpCityMultipleFields.setText(filtered);
      this.enteredCity.address = filtered;
    }
  }

  public async testSerpGoogleKeywords($event: ButtonTriggerEvent) {
    if (!this.keywordsMultipleFields.text) {
      $event.complete();
      alert('Please enter a keywords to test, e.g., Cincinnati red events');
      return;
    }
    if (!this.serpGooglekeywordsCity) {
      $event.complete();
      alert(
        'Please enter a city to filter events (events in this city will be pulled), e.g., Savannah, GA'
      );
      return;
    }

    console.log('this.this.keywordsMultipleFields.text', this.keywordsMultipleFields.text);
    const city = this.filterCountryName(this.serpGooglekeywordsCity.address);
    console.log('this.serpGooglekeywordsCity', city);

    let serpCityToAdd = this.enteredCity.address;
    serpCityToAdd = serpCityToAdd.toLocaleLowerCase().replaceAll(', usa', '');
    const serpConfig = new SerpConfig(
      false,
      0,
      0,
      true,
      'keywords',
      this.keywordsMultipleFields.text
    );

    this.schedulerApiService
      .serpApi(this.account.account.userName, city, serpConfig)
      .finally($event.complete)
      .subscribe((result: { success: boolean; events: any[]; msg: string }) => {
        console.log(result);

        if (!result || !result.success) {
          alert(result.msg);
          return;
        }
        if (!result.events.length) {
          alert(`No events found`);
          return;
        }
        result.events.forEach((x) => EventTimeService.processEventTime(x, false));
        const page = [{ events: result.events, pageLink: serpCityToAdd }];
        this.modalService.show({
          component: AddSpiderEvenetsModalComponent,
          providers: [
            { provide: AddSpiderEventsModalActions, useValue: null },
            {
              provide: AddSpiderEventsModalData,
              useValue: new AddSpiderEventsModalData(
                this.account.account.userName,
                [],
                page,
                '',
                true
              ),
            },
          ],
          panelClass: 'width-modal-90p',
        });
      });
  }

  public onAddRegionalAccount(value) {}

  tabChanged($event) {
    this.selectedTabIndex = $event;
    // select Regional account feature, load the accounts for autocomplete
    if ($event === 3 && !this.accounts.length) {
      this.accountApiService.getAccounts().subscribe((accounts) => {
        this.accounts = accounts
          .filter(
            (x) =>
              x.status === 'live' &&
              !x.isAdministrator &&
              x.userName !== this.account.account.userName
          )
          .map((x) => x.userName);
      });
    }
  }

  private filterCountryName(address: string) {
    return address.replaceAll(', USA', '').replace(/\d+/g, '');
  }

  private static parseEventbriteUrl(url: string) {
    try {
      const parsedUrl = new URL(url);
      const path = parsedUrl.pathname; // /e/event-title-words-registration-1224372183159
      // Match the final "event_id" (number) with the middle "title"
      const match = path.match(/\/e\/(.+?)-(\d+)(?:\/|$|\?)/);
      if (match) {
        const rawTitle = match[1];
        const eventId = match[2];
        // Convert the event title from URL format to a readable format
        const eventTitle = rawTitle
          .replace(/-registration$/, '') // Remove "registration" at the end if it exists
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());
        return { eventId, eventTitle };
      } else {
        return '';
      }
    } catch (err) {
      return '';
    }
  }

  private isUrl(str: string): boolean {
    try {
      const testStr =
        str.trim().startsWith('http://') || str.trim().startsWith('https://')
          ? str.trim()
          : 'https://' + str.trim();
      const url = new URL(testStr);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }
}

export class SpiderPage {
  public _id?: string;
  public socialName: string;
  public url: string;
  public tag: string;

  constructor(socialName: string, url: string, tag = '') {
    this.socialName = socialName;
    this.url = url;
    this.tag = tag;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.spider/event.spider.modal.component.ts